import { formatDistance } from 'date-fns';
import { addDirectTags } from 'helpers/tracking/utm';
import React from 'react';
import { ElementType, useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Direct } from 'store/Coin/Direct/types';
import { Coin } from 'store/Coin/types';

import withContainer from './container';
import { Item, Items, LoadMoreButton, Meta, Title } from './styles';

const POSTS_PAGE_SIZE = 6;

interface Props {
  coin: Coin;
  directs: Direct[];
  Wrapper: ElementType;
}

const MarketsDetailDirect = (props: Props) => {
  const { t } = useTranslation();
  const { directs, Wrapper } = props;
  const [amountOfPosts, setAmountOfPosts] = useState(POSTS_PAGE_SIZE);

  const onLoadMoreClick = useCallback(
    () => setAmountOfPosts(amountOfPosts + POSTS_PAGE_SIZE),
    [amountOfPosts],
  );

  if (directs.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Title>{t('assets.detail.direct.title')}</Title>
      <Items flexWrap="wrap">
        {directs
          .slice(0, amountOfPosts)
          .map((direct: Direct, index: number) => (
            <Item key={`direct-post--${index}`} width={[1, 1 / 2]}>
              <a
                href={addDirectTags(direct.link)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h3>{direct.title}</h3>
                <p>{direct.text.substr(0, 200)}</p>
                <Meta>
                  <Trans
                    i18nKey="assets.detail.direct.meta"
                    values={{
                      relativeTime: formatDistance(
                        new Date(),
                        new Date(direct.publishedAt),
                      ),
                      author: direct.author,
                      medium: t(`social-media.${direct.source.toLowerCase()}`),
                    }}
                    components={[
                      <strong key="relative-time">relative time</strong>,
                    ]}
                  />
                </Meta>
              </a>
            </Item>
          ))}

        {amountOfPosts + POSTS_PAGE_SIZE <= directs.length && (
          <LoadMoreButton onClick={onLoadMoreClick}>
            {t('cta.load-more')}
          </LoadMoreButton>
        )}
      </Items>
    </Wrapper>
  );
};

export default withContainer(MarketsDetailDirect);
